import { IApiError } from '@/models/apiError.model';
import { IAiBotSettings } from '@/models/aiBotSettings.model';

export const SLICE_NAME = 'aiBotConfig';

export interface AiBotConfigState {
  settings: IAiBotSettings | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: AiBotConfigState = {
  settings: null,
  isLoading: false,
  error: null,
};
